import { useEffect } from "react";

const RETRY_INTERVAL_MS = 100;
// 5 s max : au-delà on considère que le tag n'arrivera pas (adblocker, panne réseau).
// La doc AB Tasty ne borne pas sa boucle de retry et ne la nettoie pas ; on le fait pour ne pas
// laisser tourner un timer à vie.
const MAX_ATTEMPTS = 50;

/**
 * Libère le tag AB Tasty verrouillé par `window.lockABTastyTag` (posé dans le <head> par renderHTML)
 * une fois l'hydratation React terminée, pour que les campagnes ne mutent pas le DOM serveur avant
 * hydrateRoot (mismatch d'hydratation React 18).
 *
 * Le tag étant chargé en `defer`, `window.unlockABTasty` peut ne pas encore exister au moment du
 * premier effet : on retente toutes les 100 ms, de façon bornée.
 *
 * @see https://docs.abtasty.com/client-side/tag/troubleshootings/implementing-locking-mechanism-for-ssr
 */
export default ({ enabled }) => {
	useEffect(() => {
		if (!enabled) {
			return undefined;
		}

		let attempts = 0;
		let timeoutId;

		const tryUnlockABTasty = () => {
			if (typeof window.unlockABTasty === "function") {
				window.unlockABTasty();
				return;
			}

			attempts += 1;
			if (attempts < MAX_ATTEMPTS) {
				timeoutId = window.setTimeout(tryUnlockABTasty, RETRY_INTERVAL_MS);
			}
		};

		tryUnlockABTasty();

		return () => {
			window.clearTimeout(timeoutId);
		};
	}, [enabled]);
};
